import api from './api';

const dashboardService = {
  // Get all dashboard counts using single consolidated endpoint
  getAllCounts: async () => {
    try {
      const response = await api.get('/admin/dashboard-counts');
      console.log('Dashboard counts response:', response);
      
      // Handle different possible response structures
      let data = response.data;
      if (data?.data) {
        data = data.data;
      }
      
      // Extract total counts from nested objects
      const movies = data?.movies?.total || 0;
      const transactions = data?.transactions?.total || 0;
      const users = data?.users?.total || 0;
      const shows = data?.series?.total || 0; // Note: backend uses "series" not "shows"
      
      console.log('Parsed counts:', { movies, transactions, users, shows });
      
      return {
        movies,
        transactions,
        users,
        shows
      };
    } catch (error) {
      console.error('Error fetching dashboard counts:', error);
      return {
        movies: 0,
        transactions: 0,
        users: 0,
        shows: 0
      };
    }
  },

  // Get dashboard analytics data
  getAnalyticsData: () => {
    return api.get('/admin/analytics/dashboard');
  },

  // Get sales data
  getSalesData: (params = {}) => {
    return api.get('/admin/analytics/sales', { params });
  },

  // Get user analytics
  getUserAnalytics: (params = {}) => {
    return api.get('/admin/analytics/users', { params });
  },

  // Get revenue data
  getRevenueData: (params = {}) => {
    return api.get('/admin/analytics/revenue', { params });
  }
};

export default dashboardService;
